import type { Api, Vehicle } from '@cruz-com/lookup'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function askCruzAiLogs(params: object): Promise<Api.Result<Vehicle.AiSearch[]>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/log/ask-cruz-ai?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers,
      next: { revalidate: 5 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function toggleHideAiLog(_id: string): Promise<Partial<Vehicle.AiSearch>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/log/ask-cruz-ai/toggle-hide?_id=${_id}`, {
      method: 'PATCH',
      headers,
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
